import { IconBut } from '../ui/buttons'
import './footer.css'

let date = new Date().getFullYear()

const footerTxt = <>Copyright &copy; {date} LearnXcess</>

const links = [
    { href: "https://twitter.com", class: "fa-brands fa-x" },
    { href: "https://github.com", class: "fa-brands fa-github" },
]


export default function Footer() {
    return (
        <footer>
            <div className='content max'>
                <Socials />
                <p id="copyright" className='margin'> {footerTxt} </p>
            </div>
        </footer>
    )
}

function Socials() {
    return (
        <div className="flex mid-align" style={{ justifyContent: "space-evenly" }}>
            {
                links.map((link, i) => {
                    return <IconBut key={i} href={link.href} className={link.class} />
                })
            }
        </div>
    )

}
